import React from 'react';
import { CompareAddedIcon, ComparePlusIcon, Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { withRenderFlag } from '@beef/react';
import { COLORS } from "../../../../constants/common";
import withHoverBehavior from "../../withHoverBehavior";
import style from "../../styles.pcss";
var cx = classNames.bind(style);
var SelectedCompare = function SelectedCompare() {
  return /*#__PURE__*/React.createElement(CompareAddedIcon, {
    className: cx('icon'),
    fill: COLORS.BLACK,
    size: "s"
  });
};
var NotSelectedCompare = function NotSelectedCompare() {
  return /*#__PURE__*/React.createElement(ComparePlusIcon, {
    className: cx('icon'),
    fill: COLORS.GRAY_INACTIVE,
    size: "s"
  });
};
var COMPARE_TOOLTIP_TEXT = 'Добавить в сравнение';
var TOOLTIP_DEFAULT_POSITION = 'top';
var Icon = function Icon(_ref) {
  var inViewport = _ref.inViewport;
  return inViewport ? /*#__PURE__*/React.createElement(SelectedCompare, null) : /*#__PURE__*/React.createElement(NotSelectedCompare, null);
};
var CompareButton = function CompareButton(_ref2) {
  var _ref2$tooltip = _ref2.tooltip,
    tooltip = _ref2$tooltip === void 0 ? COMPARE_TOOLTIP_TEXT : _ref2$tooltip,
    _ref2$isVisible = _ref2.isVisible,
    isVisible = _ref2$isVisible === void 0 ? false : _ref2$isVisible,
    _ref2$isSelected = _ref2.isSelected,
    isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected,
    className = _ref2.className,
    _ref2$tooltipPosition = _ref2.tooltipPosition,
    tooltipPosition = _ref2$tooltipPosition === void 0 ? TOOLTIP_DEFAULT_POSITION : _ref2$tooltipPosition,
    inViewport = _ref2.inViewport,
    handleMouseEnter = _ref2.handleMouseEnter,
    handleMouseLeave = _ref2.handleMouseLeave,
    handleClick = _ref2.handleClick;
  var notSelectedIcon = /*#__PURE__*/React.createElement(Icon, {
    inViewport: inViewport
  });
  if (tooltip !== null) {
    notSelectedIcon = /*#__PURE__*/React.createElement(Tooltip, {
      message: tooltip,
      position: tooltipPosition
    }, /*#__PURE__*/React.createElement(Icon, {
      inViewport: inViewport
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('button', className, {
      'button--visible': isVisible || isSelected
    }),
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    role: "button",
    tabIndex: 0
  }, isSelected ? /*#__PURE__*/React.createElement(SelectedCompare, null) : notSelectedIcon);
};
export default compose(withRenderFlag({
  shouldRenderFn: function shouldRenderFn(_ref3) {
    var setIsSelected = _ref3.setIsSelected;
    return !!setIsSelected;
  }
}), withHoverBehavior)(CompareButton);